import { RootState } from '@store/store';



export const selectStatisticModel = (state: RootState) => state.preview.statisticModel;